import type { ComponentOverride } from '../types';

export const MuiListItemIcon: ComponentOverride<'MuiListItemIcon'> = {
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: 16,
        marginRight: 16,
      },
    },
  },
};
